<div class="innerpage-fullwithbanner dashboardarea clearfix">
  <div class="left">
    <h2 class="bighead">{{property.IsPortfolio ? "Portfolio Details" : "Property Details"}}</h2>
    <ul class="bread-crumbs">
      <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
      <li>
        <a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a>
      </li>
      <li>{{property.IsPortfolio ? "Portfolio Details" : "Property Details"}}</li>
    </ul>
  </div>
  <div class="right">

  </div>

</div>
<div class="clearfix"></div>
<div class="detailspage-banner" id="divPropertyViewParent">
  <!--*ngIf="activeBannerTab == 1"-->
  <div class="fav-star">

  </div>

  <div class="propertyname">
    <h3>
      {{property.Tenant}}
      <a tooltip="{{toolTipFav}}" placement="top" *ngIf="showAddToFav" href="javascript:void(0);" [class]="classToBind" (click)="addToFav(property.Id);">
        <i class="fa fa-heart-o icon"></i>
      </a>
      <span>{{property.City != null && property.City.length >  0 ? property.City + ", " : ""}}{{property.State}}</span>
    </h3>
  </div>
  <tabset #staticTabs>
    <a href="javascript:void(0);" class="open-video" *ngIf="property.VideoURL != null && property.VideoURL != ''" (click)="onVideoTabClick(video, 'commonmodal modal-lg')">Video</a>
    <tab heading="Gallery" id="tab1" (select)="onBannerTabClick(1)">
      <!--newslider stats-->

      <ngx-slick-carousel class="carousel" *ngIf="property.Images != null && property.Images.length > 0" #slickModal="slick-carousel" [config]="slideConfig"
                          (afterChange)="afterChange($event)">
        <div ngxSlickItem *ngFor="let slide of property.Images; let i=index" class="slide">
          <img (click)="open(i)" src="{{ slide.FilePath }}" attr.description="{{ slide.Description }}" attr.altText="{{slide.AlText}}" attr.Caption="{{slide.Caption}}">
        </div>
      </ngx-slick-carousel>

      <!--new slider ends-->
      <div *ngIf="property.Images == null || property.Images.length == 0" class="heightfull">
        <img src="assets/img/defaultbanner-min.png" class="img-responsiveblock" />
      </div>
    </tab>
    <tab heading="Map" *ngIf="showmap" (selectTab)="onBannerTabClick(2)">
      <div class="mapdiv">
        <div #gmap class="mapheight"></div>
      </div>
    </tab>
    <tab heading="Satellite" *ngIf="showmap" (selectTab)="onBannerTabClick(3)">
      <div class="mapdiv">
        <div #gmapSatellite class="mapheight"></div>
      </div>
    </tab>
  </tabset>
</div>

<div class="container" #hometop>
  <div class="section-margin">
    <div class="property-details clearfix" id="scrollingId-for-wizard">
      <div *ngIf="(isUserLoggedIn && canEditProperty && canEditPropertyForBroker &&  (authService.Admin() || authService.SuperAdmin() || (authService.DataEntryStaff()  && isPropertyForSale == false)))">
        <div class="floated-btn" *ngIf="(isUserLoggedIn && canEditProperty && canEditPropertyForBroker) || (isUserLoggedIn &&  (authService.Admin() || authService.SuperAdmin() || authService.DataEntryStaff()))">
          <button *ngIf="isUserLoggedIn && canEditProperty && canEditPropertyForBroker" class="btn  btn-circle btn-green" ng-reflect-placement="top" ng-reflect-tooltip="Edit"
                  placement="top" tooltip="Edit" triggers="mouseenter:mouseleave" (click)="onEditPropertyClick();">
            <i aria-hidden="true" class="icofont icofont-ui-edit icon"></i>
          </button>
          <button *ngIf="property.PropertyForId == 602 && isUserLoggedIn &&  (authService.Admin() || authService.DataEntryStaff())" class="btn  btn-circle btn-green btn-verify" ng-reflect-placement="top" ng-reflect-tooltip="Edit"
                  placement="left" tooltip="{{property.IsPortfolio ? 'Verify Portfolio' : 'Verify Property'}}" (click)="VerifyProperty(property.Id)">
            <i aria-hidden="true" class="icofont icofont-ui-check"></i>
          </button>
        </div>
      </div>
      <div class="tabheadingsoverflow">
        <ul class="tabheadings clearfix">
          <li [class.active]="activeTab == propertyTabs.Home">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Home);">
              <span class="icon-propertydetails icon"></span>Details
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Memorandom">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Memorandom);">
              <span class="icon-download icon"></span>Offering Memorandum
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Diligence">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Diligence);">
              <span class="icon-folder icon"></span>Due Diligence
            </a>
          </li>
          <li [class.active]="activeTab == propertyTabs.Comps" *ngIf="(authService.Admin()) ||(authService.SuperAdmin())|| (authService.Broker()) || (authService.DataEntryStaff())">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.Comps);">
              <span class="icon-comps icon"></span>Property History
            </a>
          </li>

          <li class="btn-group" dropdown container="body" [class.active]="activeTab == propertyTabs.Share" *ngIf="enableShare && property.PropertyForId !== 602">
            <a id="button-basic" dropdownToggle class="btn dropdown-toggle"
               aria-controls="dropdown-basic">
              <span class="icofont icofont-share icon"></span>Share
            </a>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu socialsharelinks" role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openPropertyShareModal(propertyShare, 'panlestyle',propertyTabs.Share)"><i class="fa fa-envelope-o icons"></i> Email</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.FB);"><i class="icon-facebook icons"></i> Facebook</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.LinkedIn);"><i class="icon-linkedin icons"></i> LinkedIn</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="shareOnSocialMedia(socialMedia.Twitter);"><i class="icon-twitter icons"></i> Twitter </a></li>
            </ul>
          </li>
          <li [class.active]="activeTab == propertyTabs.ActivityLog" *ngIf="viewActivityLog">
            <a href="javascript:void(0);" (click)="onTabClick(propertyTabs.ActivityLog)">
              <span class="icofont icofont-file-text icon"></span>Activity Log
            </a>
          </li>

        </ul>
      </div>
      <div class="row">



        <!--Home Start here-->
        <div class="leftside" *ngIf="activeTab !=propertyTabs.PlaceOffer">

          <div *ngIf="activeTab == propertyTabs.Home">
            <div class="border-div">
              <div class="clearfix">
                <div class="data-right">
                  <h3>
                    {{property.Tenant}}
                    <a href="javascript:void(0);" *ngIf="property.HasDuplicates && (authService.Admin() || authService.SuperAdmin() || authService.DataEntryStaff())" class="blueone" tooltip="View Duplicates" (click)="openModalForDuplicates(DuplicateProperty,'panlestyle',property.Id)" placement="top" style="line-height:32px;">
                      <i class="fa fa-files-o" style="font-size:18px;" aria-hidden="true"></i>
                    </a>
                    <span class="status" [ngClass]="{'red':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),
                                                                         'green':property.PropertyStatus === 'Available',
                                                                         'blue':property.PropertyStatus === 'Not Available',
                                                                         'orange':property.PropertyStatus === 'Under Contract','ash':property.PropertyStatus === 'Off-Market','d-orange':property.PropertyStatus === 'Pending Approval'}">{{property.PropertyStatus}}</span>
                    <button class="warningsymbol" *ngIf="property.IsSourceChanged ===1 && (authService.Admin()||authService.SuperAdmin())" container="body" triggers="hover" popover="There is an update in the property source."><i style="margin:0px 0px 0px -3px !important" class="icon icon-warning"></i></button>
                  </h3>
                  <h6>{{property.FullAddress && (property.FullAddress.length > 5) ? property.FullAddress:''}}</h6>
                  <sub class="pro-id">#{{property.PropertySequenceId}}</sub>
                  <br />
                  <a href="javascript:void(0);" *ngIf="property.ParentPortfolioName" class="btn-border btn-view-portfolio" (click)="onViewProperty(property.ParentPortfolioGuid)" style="cursor:pointer;">
                    <!--{{property.ParentPortfolioName}}--> View Portfolio
                  </a>
                  <div class="like-view-div" *ngIf="showLikesAndViews">
                    <p>Likes<span>{{property.LikesCount ? (property.LikesCount|number) :'-'}}</span></p><p>Views<span>{{property.ViewsCount ? (property.ViewsCount|number) :'-'}}</span></p>
                  </div>
                </div>
              </div>

            </div>

            <app-property-notes *ngIf="showNotes" [propertyId]="LiveListingId"></app-property-notes>
            <!--Showing portfolio Details Starts here-->
            <div class="border-div property-details-box" *ngIf="property?.IsPortfolio">
              <h2 class="mainhead">
                <span class="text">
                  Portfolio Details
                </span>
              </h2>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Type</label>
                    <h6 class="displayvalue" tooltip="{{property.AssetType}}">{{property.AssetType ? commonService.GetPropertyTypeWithCount(property.AssetType) :  '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Subcategory</label>
                    <h6 class="displayvalue" tooltip="{{property.Subcategory}}">{{property.Subcategory ? commonService.GetPropertyTypeWithCount(property.Subcategory) : '-'}}</h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Total Portfolio</label>
                    <h6 class="displayvalue">{{property.BuildingSize && property.BuildingSize != 0 ? (property.BuildingSize | number) + ' SF' : '-'}}</h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Total Land</label>
                    <h6 class="displayvalue">{{property.Land && property.Land != 0 ? (property.Land | number :'1.2-2') + ' AC' : '-'}}</h6>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Net Operating Income</label>
                    <h6 class="displayvalue">
                      {{property.NetOperatingIncome && property.NetOperatingIncome !== 0 ? '$' + (property.NetOperatingIncome | number:0) : '-'}}
                    </h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Avg. Remaining Term</label>
                    <h6 class="displayvalue">
                      {{property.PortfolioRemainingLeaseTerm ? (property.PortfolioRemainingLeaseTerm) :'-'}}
                    </h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Lease Structure</label>
                    <h6 class="displayvalue">{{property.LeaseStructure ? property.LeaseStructure : '-'}}</h6>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="property.ShowRentEscalation">
                  <div class="form-group">
                    <label class="blocklabel">Rent Escalations</label>
                    <h6 class="displayvalue">{{property.RentEscalations}}</h6>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="property.ShowOptions">
                  <div class="form-group">
                    <label class="blocklabel">Options</label>
                    <h6 class="displayvalue">
                      {{
(property.Options ? property.Options : '') +(property.OptionLength && property.Options ? ', ' : '') +
                                            (property.OptionLength ? property.OptionLength + ' ' : '') +
                                            (property.OptionLength ? '-' : '') +
                                            (property.OptionLength ? (property.OptionLength > 1 ? ' Year(s)' : ' Year(s)') : '')
                      }}
                    </h6>
                  </div>
                </div>

              </div>

              <div *ngIf="property.Description" class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label class="bluelabel margin-bottom-10">About the Property</label>
                    <p class="para prewrap">{{ property.Description }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!--Showing portfolio Details Ends here-->
            <div class="border-div property-details-box" *ngIf="!property.IsPortfolio">
              <h2 class="mainhead">
                <span class="text">Property Details</span>
              </h2>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Property Type</label>
                    <h6 class="displayvalue" tooltip="{{property.AssetType}}">{{property.AssetType ? commonService.GetPropertyTypeWithCount(property.AssetType) :  '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Subcategory</label>
                    <h6 class="displayvalue" tooltip="{{property.Subcategory}}">{{property.Subcategory ? commonService.GetPropertyTypeWithCount(property.Subcategory) : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Rating</label>
                    <h6 class="displayvalue">{{property.Rating}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Lease Structure</label>
                    <h6 class="displayvalue">{{property.LeaseStructure ? property.LeaseStructure : '-'}}</h6>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Guarantor</label>
                    <h6 class="displayvalue">{{property.Guarantor ? property.Guarantor : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Ownership Type</label>
                    <h6 class="displayvalue">{{property.OwnershipType ? property.OwnershipType : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Net Operating Income</label>
                    <h6 class="displayvalue">
                      {{
property.NetOperatingIncome && property.NetOperatingIncome !== 0 ? '$' + (property.NetOperatingIncome
                                            | number:0) : '-'
                      }}
                    </h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Remaining Term</label>
                    <h6 class="displayvalue">
                      {{property.Remaining_Term ? (property.Remaining_Term) :'-'}}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Rent Escalations</label>
                    <h6 class="displayvalue">{{property.RentEscalations}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Options</label>
                    <h6 class="displayvalue">
                      {{
 (property.Options ? property.Options : '') +
                                            (property.OptionLength&&property.Options ? ', ' : '') +
                                            (property.OptionLength ? property.OptionLength + ' ' : '') +
                                            (property.OptionLength ? '-' : '') +
                                            (property.OptionLength ? (property.OptionLength > 1 ? ' Year(s)' : ' Year(s)') : '')
                      }}
                    </h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Year Built</label>
                    <h6 class="displayvalue">{{property.YearBuilt && property.YearBuilt != 0 ? property.YearBuilt : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Building Size</label>
                    <h6 class="displayvalue">{{property.BuildingSize && property.BuildingSize != 0 ? (property.BuildingSize | number) + ' SF' : '-'}}</h6>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <label class="blocklabel">Land</label>
                    <h6 class="displayvalue">{{property.Land && property.Land != 0 ? (property.Land | number :'1.2-2') + ' AC' : '-'}}</h6>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <div class="form-group">
                    <div class="form-group">
                      <label class="blocklabel">Property Characteristics</label>
                      <h6 class="displayvalue">{{characterstics}}</h6>
                    </div>
                  </div>
                </div>
              </div>



              <div *ngIf="property.Description" class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="form-group">
                    <label class="bluelabel margin-bottom-10">About the Property</label>
                    <p class="para prewrap">{{ property.Description }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="border-div">
              <h2 class="mainhead">
                <span class="text">Investment Highlights</span>
              </h2>
              <ul class="highlights" *ngIf="property.PropertyHighlightsList && property.PropertyHighlightsList != undefined && property.PropertyHighlightsList.length > 0">
                <li *ngFor="let item of property.PropertyHighlightsList">
                  <i class="icon-tick icon"></i>
                  <h5>{{item.Title}}</h5>
                  <p *ngIf="isDescriptionVisible">{{item.Description}}</p>
                </li>
              </ul>
              <div class="text-right" *ngIf="property.PropertyHighlightsList && property.PropertyHighlightsList != undefined && property.PropertyHighlightsList.length > 0">
                <a href="javascript:void(0);" class="bluelink" (click)="onToggleDescriptionVisibility()">{{toggleDetailsText}}</a>
              </div>
              <div class="nodata" *ngIf="!property.PropertyHighlightsList || property.PropertyHighlightsList == undefined || property.PropertyHighlightsList.length == 0">
                <!--<i class="icofont icofont-warning icon"></i>-->
                <p>Investment Highlights are coming soon!</p>
              </div>
            </div>
            <div class="border-div" *ngIf="property.IsShowRentSchedule">
              <div class="floatinghead clearfix">
                <h2 class="mainhead">
                  <span class="text">NOI / Rent Schedule</span>
                </h2>

              </div>
              <div>
                <app-rent-term-table [IsDataEntryProperty]="true" [propertyId]="propertyId" [InitialLoad]="true" [IsEditAllowed]="false"></app-rent-term-table>
              </div>
            </div>

            <!--Showing portfolio property list Starts Here-->
            <div class="border-div" *ngIf="property.IsPortfolio || property.ParentPortfolioName">
              <div class="floatinghead floatinghead-xs clearfix">
                <div class="clearfix p-1">
                  <div class="floatinghead floatinghead-xs clearfix">
                    <div class="pull-left"><h2 class="mainhead"><span class="text">Portfolio Properties</span></h2></div>
                    <div class="pull-right clearfix">
                      <button class="btn-border margin-right-10 btn adduserbtn pull-right margin-bottom-15" *ngIf="propertiesEx?.length !== 0 " (click)="exportToExcel();">Export To Excel</button>
                      <div class="select-dropdown multiselectdesign pull-right multi-check-dropdown margin-right-10">
                         <mat-form-field  >
                          <mat-select [(ngModel)]="selectedColumns" [multiple]="true">
                            
                            @if (selectedColumns?.length > 1) {
                              <mat-select-trigger>
                                <span>{{ selectedColumns?.length }} checked</span>
                              </mat-select-trigger>
                            }
                            <mat-option *ngFor="let column of tableColumns" class="multi-dropdown-item" [value]="column">
                              {{column.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                  <thead>
                    <tr>
                      <th class="remove" style="position:static; cursor:default" ng-disabled="true" data-orderable="false"></th>
                      <th class="property-name-column sticky-left z-100">Tenant Name</th>
                      <th [hidden]="hideColumn(1)">OM</th>
                      <th [hidden]="hideColumn(2)">State</th>
                      <th [hidden]="hideColumn(3)">City</th>
                      <th [hidden]="hideColumn(5)">Status</th>
                      <th [hidden]="hideColumn(6)">Asking Price</th>
                      <th [hidden]="hideColumn(7)">Rent / NOI</th>
                      <th [hidden]="hideColumn(8)">Cap Rate</th>
                      <th [hidden]="hideColumn(9)">Rem. Term</th>
                      <th [hidden]="true">Rank</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let prop of portfolioProperties;let i = index">
                      <td [ngClass]="{'be-list': (prop.PropertyForId == 601 )}">
                        <a href="#" routerLink="/viewdeproperty/{{prop.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url}">
                          <div class="property-image" *ngIf="prop.FilePath !=null" [ngStyle]="{'background-image': 'url(' + prop.FilePath + ')'}"></div>
                          <div class="property-image" *ngIf="prop.FilePath == null" style="background-image:url(../../assets/img/default-property_1.png)"></div>
                        </a>
                      </td>
                      <td class="sticky-left">
                        <p>
                          <a href="#" routerLink="/viewdeproperty/{{prop.Guid}}" (click)="onRedirection();" [queryParams]="{prevroute:'Live Listings',link:router.url}">{{ prop.PropertyName }}</a>
                        </p>
                      </td>
                      <td [hidden]="hideColumn(1)">
                        <a *ngIf="prop.OMFilePath!=null" href={{prop.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(prop.OMFilePath!=null)}">
                          <i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}
                        </a>
                      </td>
                      <td [hidden]="hideColumn(2)"><p>{{prop.State ? prop.State : '-'}}</p></td>
                      <td [hidden]="hideColumn(3)"><p>{{prop.City ? prop.City : '-'}}</p></td>
                      <td [hidden]="hideColumn(5)"><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">{{ prop.PropertyStatus }}</p></td>
                      <td [hidden]="hideColumn(6)">
                        <p *ngIf="!prop.Unpriced" class="whitespacenowrap">{{(prop.Price) ? '$ '+ (prop.Price | number:0) : '-'}}</p>
                        <p *ngIf="prop.Unpriced" class="whitespacenowrap">Unpriced</p>
                      </td>
                      <td [hidden]="hideColumn(7)"><p class="whitespacenowrap">{{(prop.RentNOI) ? '$ '+ (prop.RentNOI | number:0) : '-'}}</p></td>
                      <td [hidden]="hideColumn(8)">
                        <p *ngIf="prop.CharacteristicsId == 1">ZCF</p>
                        <p *ngIf="prop.CharacteristicsId == 0">{{ (prop.CapRate) ? (prop.CapRate | number : '1.2-2') + '%' : '-' }}</p>
                      </td>
                      <td [hidden]="hideColumn(9)"><p>{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-' }}</p></td>
                      <td [hidden]="true"><p>{{ prop.Rank }}</p></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="portfolioProperties?.length == 0&&!IsLoadDES ">
                      <td colspan="10" class="odd no-data-available">
                        <div class="nodata">
                          <i class="fa fa-exclamation-triangle icon"></i>
                          <p>No Data Available</p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <!--Showing portfolio property list end here-->
          </div>
        </div>
        <div class="rightside clearfix" *ngIf="activeTab ==propertyTabs.Home">
          <div class="halfwidth1100">
            <div class="border-div pb-0">
              <div class="askingprice mb-0">
                <span class="two_sep">
                  <h3>
                    <span>Asking Price</span>
                    <span *ngIf="property.Unpriced">Unpriced</span>
                    <span *ngIf="!property.Unpriced">{{(property.IsShowPrice) ? '$ '+(property.Price | number:0) : '-'}}</span>
                  </h3>
                </span>
                <span class="right_cont two_sep">
                  <h3 class="pricedetails">
                    <span>Cap Rate</span>
                    <span *ngIf="capratetext == 'ZCF'">{{capratetext}}</span>
                    <span *ngIf="capratetext != 'ZCF'">{{ (property.CapRate && property.IsShowPrice) ? (property.CapRate | number : '1.2-2') + ' %' : '-' }}</span>
                  </h3>
                </span>
              </div>
            </div>
          </div>
          <div class="halfwidth1100" *ngIf="showContactUs && property.PropertyContactPersonsList && property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0">
            <div class="border-div ">
              <h2 class="mainhead">
                <span class="text">Contact Us</span>
              </h2>
              <ul class="contacts" *ngIf="property.PropertyContactPersonsList && property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0">
                <li class="clearfix" *ngFor="let item of property.PropertyContactPersonsList">
                  <div *ngIf="item.ContactTypeId != contactType.Others">
                    <div class="imgblock">
                      <img [src]="item.Photo != '' ? item.Photo : defaultProfilePic">
                    </div>
                    <div class="data">
                      <h3>{{item.Name}}<span *ngIf="item.ContactTypeId == contactType.Primary"> - Primary</span></h3>
                      <p>
                        <i class="icon-phone icon"></i>{{item.PhoneNo | phone}}
                      </p>
                      <p>
                        <i class="icon-message icon"></i>{{item.EmailID}}
                      </p>
                      <p *ngIf="item.License != null && item.License != ''">
                        <i class="icon-license icon"></i>{{item.License}}
                      </p>
                      <p>
                        <a *ngIf="item.UserLinkedInProfile != null && item.UserLinkedInProfile != ''" target="_blank" href="{{item.UserLinkedInProfile}}"><i class="icon fa fa-linkedin-square" aria-hidden="true"></i></a>
                        <a target="_blank" href="https://www.facebook.com/BeNetLease"><i class="fa fa-facebook-square" aria-hidden="true"></i></a>
                        <a style="margin-left: 10px;" target="_blank" href="https://twitter.com/BeNetLease"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
                        <a style="margin-left: 10px;" target="_blank" href="https://www.instagram.com/benetlease/?igshid=N2ZiY2E3YmU%3D"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="nodata" *ngIf="!property.PropertyContactPersonsList || property.PropertyContactPersonsList == undefined || property.PropertyContactPersonsList.length == 0">
                <!--<i class="icofont icofont-warning icon"></i>-->
                <p>No Contacts Available</p>
              </div>
              <div class="text-center" *ngIf="property.PropertyStatus === 'Available' && (authService.Principal() || authService.Principal1031() || authService.ExternalBroker()) ">
                <button class="btn btn-success btn-lg btn-send-inquiry" id="btnSentInquiry" (click)="openInquiryModal(template,'panlestyle')">
                  Send Inquiry
                </button>
              </div>
              <h5 *ngIf="property.PropertyContactPersonsList && property.PropertyContactPersonsList != undefined && property.PropertyContactPersonsList.length > 0">
                <span *ngIf="hasOtherContactType">
                  In Association with
                </span>
                <div *ngFor="let item of property.PropertyContactPersonsList">
                  <div *ngIf="item.ContactTypeId == contactType.Others">
                    {{item.Name}} {{item.License}}
                  </div>
                </div>
              </h5>
            </div>
          </div>
          <div class="text-center" *ngIf="property.PropertyStatus === 'Available' && property.PropertyContactPersonsList?.length === 0 && (authService.Principal() || authService.Principal1031() || authService.ExternalBroker())">
            <button class="btn btn-success btn-lg btn-send-inquiry" id="btnSentInquiry" (click)="openInquiryModal(template,'panlestyle')">
              Send Inquiry
            </button>
          </div>
        </div>
        <!--Home Ends here-->
        <!--Offering Memorandom Start here-->
        <div class="col-md-12">
          <div class="border-div" *ngIf="activeTab == propertyTabs.Memorandom">
            <div class="nodata" *ngIf="offeringMemorandomDocList == null || offeringMemorandomDocList.length == 0">
              <p>Offering Memorandum is coming soon! Contact Broker for more details.</p>
            </div>
            <div class="table-responsive" *ngIf="offeringMemorandomDocList != null && offeringMemorandomDocList.length > 0 && (docAccessOutput.RequestForOfferAccessId == docAccessStatus.Accepted || canEditProperty)">
              <table class="table basictable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Document Name</th>
                    <th>Date</th>
                    <th>Category</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of offeringMemorandomDocList; let i = index" [class.highlighted]="i == 0">
                    <td>
                      <p>{{i+1}}</p>
                    </td>
                    <td>
                      <a *ngIf="isUserLoggedIn" onMouseOver="this.style.color='#198fde'"
                         onMouseOut="this.style.color='#616161'" href={{item.FilePath}} target="_blank"
                         (click)="saveOfferingMemorandomToAuditLog()">
                        {{item.Name}}
                      </a>
                    </td>
                    <td>
                      <p>
                        {{item.UploadedDate ? (Validation.formatDate(Validation.convertUTCDateToLocalDate(item.UploadedDate), 'MM/dd/yyyy')) : '-'}}
                      </p>
                    </td>
                    <td>
                      <p>{{item.Category}}</p>
                    </td>
                    <td>
                      <a class="view" href={{item.FilePath}} target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                         ng-reflect-placement="top" triggers="hover" (click)="saveOfferingMemorandomToAuditLog()">
                        <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                      </a>
                      <a *ngIf="item.FilePath.includes('.pdf')" href="javascript:void(0);" tooltip="Preview" (click)="previews(preview,'pdf-view-modal', item)" placement="top">
                        <i aria-hidden="true" class="fa fa-eye"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="offeringMemorandomDocList != null && offeringMemorandomDocList.length > 0 && docAccessOutput.RequestForOfferAccessId == docAccessStatus.New && !canEditProperty">
              <app-nda-agreement [ndaDetails]="ndaDetails"></app-nda-agreement>
              <div class="margin-top-30">
                <label class="custom-checkbox" for="checkboxTerms">
                  <input class="border-checkbox" id="checkboxTerms" type="checkbox" [(ngModel)]="isMemorandomTandC">
                  <i class="helper"></i>I agree to the above terms and conditions
                </label>
              </div>
              <div class="text-right">
                <button class="btn btn-success btn-lg" [disabled]="!isMemorandomTandC" (click)="onMemorandomProceedClick()">
                  Proceed
                </button>
              </div>
            </div>
            <div *ngIf="offeringMemorandomDocList != null && offeringMemorandomDocList.length > 0 && docAccessOutput.RequestForOfferAccessId == docAccessStatus.Pending && !canEditProperty">
              <h2 class="mainhead">
                <span class="text">
                  Pending Approval
                </span>
              </h2>
              Your request to view the Offering memorandum document is pending approval. You will receive an email upon the acceptance/rejection shortly. In meantime, you can browse through our properties!
            </div>
            <div *ngIf="offeringMemorandomDocList != null && offeringMemorandomDocList.length > 0 && docAccessOutput.RequestForOfferAccessId == docAccessStatus.Rejected && !canEditProperty">
              <h2 class="mainhead">
                <span class="text">
                  Request Rejected
                </span>
              </h2>
              <div>
                Your request to view the Offering memorandum document has been rejected. Please get in touch with us to know more.
                <br />
                <b>Call : 646-770-0659</b>
                <br />
                <b>Email : info&#64;tradenetlease.com</b>
              </div>
            </div>
          </div>
          <div class="border-div" *ngIf="this.visewDocRequestList==true && activeTab == propertyTabs.Memorandom">
            <doc-access-listing [property]="this.property" [AccessAdded]="accessAdded"></doc-access-listing>
          </div>
        </div>
        <!--Offering Memorandom Ends here-->
        <!--Inquiries Start here-->
        <div class="col-md-12">
          <div *ngIf="canEditProperty && activeTab == propertyTabs.Inquiries">
            <property-inquiries-list [propertyGuid]="propertyGuid"></property-inquiries-list>
            <br />
          </div>
        </div>
        <!--Inquiries Ends here-->
        <!--Comps Start here-->
        <div class="col-md-12">
          <div *ngIf="canEditProperty && activeTab == propertyTabs.Comps">
            <app-property-comps [propertyId]="propertyId" [property]="property" [YearBuilt]="property.YearBuilt" [IsDataEntryPrperty]="true" [canEditHistory]="canEditHistory"></app-property-comps>
            <br />
          </div>
        </div>
        <!--Comps End here-->
        <!--Due Diligence Start here-->
        <div class="border-div min-heightcontainer" *ngIf="activeTab == propertyTabs.Diligence">
          <app-due-dilignence-list [propertyId]="property.Id" [property]="property" [canEditProperty]="canEditProperty" [docAccessStatus]="docAccessStatus"></app-due-dilignence-list>
        </div>
        <!--<div class="col-md-12">
          <div class="border-div min-heightcontainer" *ngIf="activeTab == propertyTabs.Diligence">
            <div class="nodata" *ngIf="dueDiligenceDocList == null || dueDiligenceDocList.length == 0">
              <p>Due Diligence materials are coming soon! Contact Broker for more details.</p>
            </div>
            <div class="table-responsive" *ngIf="dueDiligenceDocList != null && dueDiligenceDocList.length > 0 && (docAccessOutput.RequestForDueDiligenceAccessId == docAccessStatus.Accepted || canEditProperty)">
              <table class="table basictable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Document Name</th>
                    <th>Date</th>
                    <th>Category</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dueDiligenceDocList; let i = index"  [class.highlighted]="i == 0">
                    <td>
                      <p>{{i+1}}</p>
                    </td>
                    <td>
                      <p>{{item.Name}}</p>
                    </td>
                    <td>
                      <p>
                        {{item.UploadedDate ? (Validation.formatDate(Validation.convertUTCDateToLocalDate(item.UploadedDate), 'MM/dd/yyyy')) : '-'}}
                      </p>
                    </td>
                    <td>
                      <p>{{item.Category}}</p>
                    </td>
                    <td>
                      <a class="view" href={{item.FilePath}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download"
                         ng-reflect-placement="top" triggers="hover" (click)="saveDueDiligenceToAuditLog()">
                        <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngIf="dueDiligenceDocList != null && dueDiligenceDocList.length > 0 && docAccessOutput.RequestForDueDiligenceAccessId == docAccessStatus.New && !canEditProperty">
              <app-nda-agreement [ndaDetails]="ndaDetails"></app-nda-agreement>
              <div class="margin-top-30">
                <label class="custom-checkbox" for="checkboxTerms">
                  <input class="border-checkbox" id="checkboxTerms" type="checkbox" [(ngModel)]="isDueDiligenceTandC">
                  <i class="helper"></i>I agree to the above terms and conditions
                </label>
              </div>
              <div class="text-right">
                <button class="btn btn-success btn-lg" [disabled]="!isDueDiligenceTandC" (click)="onDueDiligenceProceedClick()">
                  Proceed
                </button>
              </div>
            </div>
            <div *ngIf="dueDiligenceDocList != null && dueDiligenceDocList.length > 0 && docAccessOutput.RequestForDueDiligenceAccessId == docAccessStatus.Pending && !canEditProperty">
              <h2 class="mainhead">
                <span class="text">
                  Pending Approval
                </span>
              </h2>
              <div>
                Your request to view the Due Diligence documents is pending approval. You will receive an email upon the acceptance/rejection shortly. In meantime, you can browse through our properties!
              </div>
            </div>
            <div *ngIf="dueDiligenceDocList != null && dueDiligenceDocList.length > 0 && docAccessOutput.RequestForDueDiligenceAccessId == docAccessStatus.Rejected && !canEditProperty">
              <h2 class="mainhead">
                <span class="text">
                  Request Rejected
                </span>
              </h2>
              <div>
                Your request to view the Due Diligence documents has been rejected. Please get in touch with us to know more.
                <br />
                <b>Call : 646-770-0659</b>
                <br />
                <b>Email : info@tradenetlease.com</b>
              </div>
            </div>
          </div>
        </div>-->
        <!--Due Diligence End here-->
        <!--Offer list Start here-->
        <div class="col-md-12">
          <div *ngIf="canEditProperty && activeTab == propertyTabs.Offer">
            <property-offers-list (showOffer)="showOffer($event)" [propertyGuid]="propertyGuid"></property-offers-list>
          </div>
        </div>
        <!--Offer list End here-->
        <!--Offer list Start here-->
        <div class="col-md-12">
          <div *ngIf="activeTab == propertyTabs.OfferDetail">
            <property-offers-list (showOffer)="showOffer($event)" [propertyGuid]="propertyGuid"></property-offers-list>
          </div>
        </div>
        <!--Offer list End here-->
        <!--Place offer Start here-->
        <div id="divPlaceOfferParent" [ngClass]="{'show':activeTab == propertyTabs.PlaceOffer,'hide':activeTab != propertyTabs.PlaceOffer}">
          <place-offer [inputOfferGuid]="propertyGuid" [IsFromPropertyView]="true"></place-offer>
        </div>
        <!--Place offer Ends here-->
        <!--Analytics Start here-->
        <div class="col-md-12">
          <div *ngIf="activeTab == propertyTabs.Analytics">
            <app-analytics [tenantId]="property.TenantId" [propertyId]="actualPropertyId" [property]="property"></app-analytics>
            <br />
          </div>
        </div>
        <!--Analytics Ends here-->
        <!--Audit trail Start here-->
        <div id="divMessageParent" *ngIf="activeTab == propertyTabs.ActivityLog">
          <div class="col-md-12">
            <app-audit-trail [getPropertyId]="property.Id" [propertyView]="true" [propertyModuleTypeID]="305"></app-audit-trail>
          </div>
        </div>
        <!--Audit trail Ends here-->
        <!--Duplicate property Start here-->
        <div *ngIf="activeTab == propertyTabs.Duplicates">
          <div class="col-md-12">
            <app-property-duplicates [PropertyId]="property.Id" [Type]="2"></app-property-duplicates>
          </div>
        </div>
        <!--Duplicate property End here-->
      </div>
    </div>
    <h2 class="mainhead" *ngIf="similarProperties.length>0 && activeTab ==propertyTabs.Home && !authService.Admin()&& !authService.SuperAdmin()">
      <span class="text">Similar Properties</span>
    </h2>
    <div class="row" *ngIf="activeTab ==propertyTabs.Home && !authService.Admin() && !authService.SuperAdmin()">
      <div class="col-md-4 col-lg-3 col-sm-6 col-xs-6 fullwidth600" *ngFor="let item of similarProperties">
        <be-property-card [property]="item" (propertyGuid)="onViewPropertyEvent($event)"></be-property-card>
      </div>
    </div>
  </div>
</div>



<ng-template #template class="pull-left">
  <be-place-offer [modalRef]="modalRef" [placeOfferInputModel]="placeOfferInputModel" [showFileUpload]="showFileUpload" (offerPlaced)="getOfferPlaced($event)"></be-place-offer>
</ng-template>

<ng-template #inquiry class="pull-left">
  <be-place-offer [modalRef]="modalRef" [placeOfferInputModel]="placeOfferInputModel" [showFileUpload]="showFileUpload" (inquiryPlaced)="getInquiryPlaced($event)"></be-place-offer>
</ng-template>

<ng-template #login>
  <app-login-form [modalRef]="modalRef"></app-login-form>
</ng-template>

<ng-template #video>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Video</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="embed-responsive embed-responsive-16by9">
      <iframe class="embed-responsive-item" [src]="videoUrl" frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
    </div>
  </div>
</ng-template>

<ng-template #DuplicateProperty>
  <app-duplicate-property-list [PropertyId]="selectedPropertyIdForDuplicates" [modalRef]="modalRefDuplicate" [Type]="2"></app-duplicate-property-list>
</ng-template>

<ng-template #loginpopup>
  <app-login-form [modalRef]="modalRef"></app-login-form>
</ng-template>
<ng-template #propertyShare>
  <app-share-property [property]="property" [modalRef]="modalRef"></app-share-property>
</ng-template>
<ng-template #preview>
  <div class="modal-header">
    <!--<h4 class="modal-title pull-left">{{docPreview.Name}}</h4>-->
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="docPreview.FilePath" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>

  <!--<pdf-viewer [external-link-target]="'blank'" [show-all]="true" [show-borders]="true" [original-size]="true" [src]="docPreview.Url"
              [render-text]="true"
              style="display: block;"></pdf-viewer>-->
</ng-template>

<button id="openModalButton" [hidden]="true" (click)="openLoginModal(loginpopup,'commonmodal',property.Guid)"></button>
